import { reactive } from 'vue'
const state = reactive({
  data: null,
})

export const checkPartner = async () => {
  try {
    const response = await fetch(
      `get/api/template/partner_pass/check_is_logged_in`
    )

    if (!response.ok) {
      throw new Error('Something went wrong')
    }

    return await response.json()
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}
